import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../evaluation_event_educator_story';

export default function Launcher(props) {
  const config = useDialogConfig();

  const evaluationEventEducator = useConnect('evaluationEventEducator.byId', {
    id: config.params.evaluationEventEducatorId
  });

  if (evaluationEventEducator.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      evaluationEventEducator={evaluationEventEducator}
      onClose={props.onClose}
    />
  );
};
